// extracted by mini-css-extract-plugin
export default {"imgWrapper":"styles_imgWrapper__Fwzh2","bgImg":"styles_bgImg__-yTlF"};